import {  ODSCardImage, ODSColumn, ODSText } from "@telekom-ods/react-ui-kit"
import React from "react"


const ErrorBlock = () => {
    return (
        <>
            <ODSCardImage style={{marginTop:'1rem'}}
                action={function Qa() { }}
                // actionSlot={<ODSButton label="Reload once" size="small" />}
                aspectRatioKeeperProps="43"
                backgroundImage="https://dtdl-static-natco.eshop.yo-digital.com/resize-image?f=assets/at/8018ada3-32c3-4bca-9fb1-e2ec44260306_w382_h229_s22189.png"
                contentSlot={
                <ODSColumn style={{ gap: 'var(--spacing-component-3)' }}>
                    <ODSText 
                    aria-label="Label Heading" as="h1" role="link"
                     style={{ color: 'var(--colours-basic-text)', 
                     font: 'var(--title-s)',
                      letterSpacing: 'var(--title-s-letter-spacing)', margin: 0, order: 2 }}
                       tabIndex={0}>
                          Well this is awkward

                           </ODSText>
                           <ODSText aria-hidden="true" 
                            as="span" style={{ color: 'var(--colours-basic-text)', 
                            font: 'var(--body-l)',
                             letterSpacing: 'var(--body-l-letter-spacing)', order: 1 }}
                             ></ODSText>
                             <ODSText as="p" style={{ color: 'var(--colours-basic-text)',
                              font: 'var(--body-m-bold)',
                               letterSpacing: 'var(--body-m-bold-letter-spacing)',
                                margin: 'var(--spacing-component-3) 0 0', order: 3 }}>
                                   The page you’re looking for took the day off and is now hiding
amongst many separate lines of code! That’s our bad..{' '}
                                    </ODSText></ODSColumn>}
                imagePosition="right"
              showAction
                showContent
                size="hero"
            />
        </>
    )
}

export default ErrorBlock